<div class="monthpicker">
  <div class="input-group ">
    <p class="form-control">{{ text() }}</p>
    <span class="input-group-btn">
      <button class="btn btn-secondary" type="button" (click)="toggle($event)">
        <i class="fa fa-calendar" aria-hidden="true"></i>
      </button>
    </span>
  </div>

  <div class="modal" [class.open]="opened">
    <div class="year">
      <span class="op dec" (click)="sumYear($event, -1)">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
      </span>
      <span class="name">{{ valueModal.year }}</span>
      <span class="op inc" (click)="sumYear($event, 1)">
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </span>
    </div>
    <div class="month">
      <div class="group">
        <span [class.selected]="valueModal.month === 1" (click)="setMonth($event, 1)">Jan</span>
        <span [class.selected]="valueModal.month === 2" (click)="setMonth($event, 2)">Fev</span>
        <span [class.selected]="valueModal.month === 3" (click)="setMonth($event, 3)">Mar</span>
        <span [class.selected]="valueModal.month === 4" (click)="setMonth($event, 4)">Abr</span>
      </div>
      <div class="group">
        <span [class.selected]="valueModal.month === 5" (click)="setMonth($event, 5)">Mai</span>
        <span [class.selected]="valueModal.month === 6" (click)="setMonth($event, 6)">Jun</span>
        <span [class.selected]="valueModal.month === 7" (click)="setMonth($event, 7)">Jul</span>
        <span [class.selected]="valueModal.month === 8" (click)="setMonth($event, 8)">Ago</span>
      </div>
      <div class="group">
        <span [class.selected]="valueModal.month === 9" (click)="setMonth($event, 9)">Set</span>
        <span [class.selected]="valueModal.month === 10" (click)="setMonth($event, 10)">Out</span>
        <span [class.selected]="valueModal.month === 11" (click)="setMonth($event, 11)">Nov</span>
        <span [class.selected]="valueModal.month === 12" (click)="setMonth($event, 12)">Dez</span>
      </div>
    </div>
  </div>
</div>
